import {
  ChangeDetectorRef,
  AfterViewInit,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Background, BtnVariant, CopyStyle, Theme } from './hero-tall.interface';
import { Subject } from 'rxjs';
import { delay } from 'rxjs/operators';
import { ButtonStyle, ButtonType } from '../../button';
import { BreadcrumbInput } from '../../breadcrumb';
import { ScriptService } from '../services/script.service';
import { ButtonSize } from '../../button';
import { DeviceBreakPoint } from '../../shared/enum';

@Component({
  selector: 'vm-hero-tall',
  templateUrl: './hero-tall.component.html',
  styleUrls: ['./hero-tall.component.scss'],
})
export class HeroTallComponent implements OnInit, AfterViewInit {
  @Input() buttonText: string;
  @Input() buttonLink: string;
  @Input() btnType: ButtonType;
  @Input() btnVariant: string;
  @Input() btnStyle: ButtonStyle = -1;
  @Input() btnSize: ButtonSize;
  @Input() copyStyle: CopyStyle;
  @Input() heroBgImage: string;
  @Input() heroBgMobileImage: string;
  @Input() heroBgTabletImage: string;
  @Input() heroText: string;
  @Input() heroHeader: string;
  @Input() heroImage: string;
  @Input() heroMobileImage: string;
  @Input() renderImageOnBackground = false;
  @Input() heroTabletImage: string;
  @Input() heroVideo: string;
  @Input() heroTabletVideo: string;
  @Input() heroMobileVideo: string;
  @Input() theme: Theme;
  @Input() background: Background;
  @Input() url: string;
  @Input() breadcrumb: BreadcrumbInput;
  @Input() doNotInitParallax = false; // Must be always false apart from Compax content_pages project
  @Input() runInitParallax = true;
  @Output() okButtonClick: EventEmitter<any> = new EventEmitter();
  @ViewChild('heroBanner') heroBanner: ElementRef;
  ButtonSize = ButtonSize;
  ButtonStyle = ButtonStyle;
  CopyStyle = CopyStyle;
  applyTransition = false;
  transitionSubject = new Subject<boolean>();
  Theme = Theme;
  assetsPrefix = '';
  setHeight: string;
  DeviceBreakPoint = DeviceBreakPoint;

  constructor(private script: ScriptService, @Inject('env') private env, private changeDetector: ChangeDetectorRef) {
    this.assetsPrefix = this.env.assetsUrl;
  }

  ngOnInit() {
    this.applyTransition = false;
    this.script
      .load(this.assetsPrefix, 'skrollr')
      .then((data) => {
        if (this.runInitParallax) {
          this.script.runParallax();
        }
        this.transitionTrigger();
      })
      .catch((error) => console.log(error));
  }

  transitionTrigger() {
    this.transitionSubject.next(true);
  }

  ngAfterViewInit() {
    this.transitionSubject.pipe(delay(200)).subscribe((loaded) => {
      if (loaded === true) {
        this.applyTransition = true;
      }
    });
  }

  public onOkClicked(event: any): void {
    this.okButtonClick.emit(event);
  }

  getDynamicHeight(param) {
    if (param) {
      if (
        window.innerWidth >= DeviceBreakPoint.Mobile &&
        window.innerWidth < DeviceBreakPoint.SmallerTablet &&
        param.intrinsicWidth >= DeviceBreakPoint.Mobile &&
        param.intrinsicWidth < DeviceBreakPoint.SmallerTablet
      ) {
        this.setHeight = (param.intrinsicHeight / param.intrinsicWidth) * window.innerWidth + 'px !important';
      } else if (
        window.innerWidth >= DeviceBreakPoint.SmallerTablet &&
        window.innerWidth < DeviceBreakPoint.Desktop &&
        param.intrinsicWidth >= DeviceBreakPoint.SmallerTablet &&
        param.intrinsicWidth < DeviceBreakPoint.Desktop
      ) {
        this.setHeight = (param.intrinsicHeight / param.intrinsicWidth) * window.innerWidth + 'px !important';
      } else if (window.innerWidth >= DeviceBreakPoint.Desktop && param.intrinsicWidth >= DeviceBreakPoint.Desktop) {
        this.setHeight = (param.intrinsicHeight / param.intrinsicWidth) * window.innerWidth + 'px !important';
      }
      if (this.setHeight) {
        this.heroBanner.nativeElement.setAttribute('style', 'min-height: ' + this.setHeight);
      }
      this.changeDetector.detectChanges();
    }
  }
}
